import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../components/atoms/Icon';
import LandingHeader from '../components/organisms/LandingHeader';

const AssessmentCompletePage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { applicationId, interviewId } = location.state || {};
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    // Slight delay for smooth entrance
    setTimeout(() => setShowContent(true), 300);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <LandingHeader />

      <div className="max-w-3xl mx-auto px-4 py-12">
        {/* Success Card */}
        <div className={`bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden transition-all duration-500 ${showContent ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          {/* Green top bar */}
          <div className="h-1.5 bg-teal-600" />

          <div className="p-8 text-center">
            {/* Success icon */}
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-5">
              <Icon name="check_circle" size={40} className="text-teal-600" />
            </div>

            <h1 className="text-2xl font-bold text-gray-900 mb-2">Interview Completed</h1>
            <p className="text-gray-600 mb-6">
              Your responses have been recorded and are being evaluated by our AI system.
            </p>

            {/* Timeline */}
            <div className="grid grid-cols-3 gap-4 mb-8">
              <div className="text-center">
                <div className="w-10 h-10 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-2">
                  <Icon name="check" size={20} className="text-teal-600" />
                </div>
                <p className="text-xs font-semibold text-teal-700">Submitted</p>
                <p className="text-xs text-gray-500">Just now</p>
              </div>
              <div className="text-center">
                <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-2">
                  <Icon name="hourglass_top" size={20} className="text-amber-600" />
                </div>
                <p className="text-xs font-semibold text-amber-700">Under Review</p>
                <p className="text-xs text-gray-500">1-2 business days</p>
              </div>
              <div className="text-center">
                <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-2">
                  <Icon name="mail" size={20} className="text-gray-400" />
                </div>
                <p className="text-xs font-semibold text-gray-500">Results</p>
                <p className="text-xs text-gray-500">Via email</p>
              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-gray-100 mb-6" />

            {/* AI Trainer CTA */}
            <div className="bg-gradient-to-r from-teal-50 to-cyan-50 border border-teal-200 rounded-xl p-5 mb-6 text-left">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Icon name="psychology" size={24} className="text-white" />
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold text-gray-900 mb-1">Want to improve your interview skills?</h3>
                  <p className="text-sm text-gray-600 mb-3">
                    Practice with our AI Interview Trainer — get real-time feedback on your answers, body language tips, and personalized coaching to boost your confidence.
                  </p>
                  <button
                    onClick={() => navigate('/ai-trainer')}
                    className="inline-flex items-center gap-1.5 px-4 py-2 bg-teal-600 text-white text-sm font-semibold rounded-lg hover:bg-teal-700 transition-colors"
                  >
                    <Icon name="rocket_launch" size={16} />
                    Start AI Training
                  </button>
                </div>
              </div>
            </div>

            {/* Info row */}
            <div className="flex items-center justify-center gap-6 text-xs text-gray-500 mb-6">
              <span className="flex items-center gap-1">
                <Icon name="lock" size={14} /> Your data is secure
              </span>
              <span className="flex items-center gap-1">
                <Icon name="visibility_off" size={14} /> Scores are confidential
              </span>
            </div>

            {/* Actions */}
            <div className="flex gap-3 justify-center">
              <button
                onClick={() => navigate('/candidate/applications')}
                className="px-5 py-2.5 bg-teal-600 text-white text-sm font-semibold rounded-lg hover:bg-teal-700 transition-colors flex items-center gap-1.5"
              >
                <Icon name="work" size={16} />
                My Applications
              </button>
              <button
                onClick={() => navigate('/jobs')}
                className="px-5 py-2.5 text-gray-700 text-sm font-semibold border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors flex items-center gap-1.5"
              >
                <Icon name="search" size={16} />
                Browse More Jobs
              </button>
            </div>
          </div>
        </div>

        {/* Interview ID */}
        {interviewId && (
          <p className="text-center text-xs text-gray-400 mt-4">
            Reference: {interviewId}
          </p>
        )}
      </div>
    </div>
  );
};

export default AssessmentCompletePage;
